<template>
  <div :class="`plan-card ${ name }`">
    <div class="plan-name">{{ plans[name].name }}</div>
    <div class="plan-desc">{{ plans[name].description() }}</div>
    <div class="plan-hr"></div>

    <div class="features-wrapper">
      <div class="features">
        <div class="feature" v-for="(feature, key) in plans[name].features" :key="key">
          <div class="feature-icon">
            <inline-svg src="/images/v4/svg/icon-checkmark.svg" />
          </div>
          <div class="feature-text">
            {{ feature }}
          </div>
        </div>
      </div>
    </div>

    <div class="get-started">
      <a :href="plans[name].button.link" :class="plans[name].button.cssClass">
        <span class="button-text-regular">
          {{ plans[name].button.text[0] }}
        </span>
        <span class="button-text-short">
          {{ plans[name].button.text[1] ?? plans[name].button.text[0] }}
        </span>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PricingCard',
  props: {
    name: String,
    monthly: Boolean,
  },
  data() {
    return {
      plans: {
        free: {
          name: 'Бесплатно',
          description: () => 'Оплата не требуется',
          features: [
            '1 рабочее пространство',
            'Безлимит файлов',
            'Безлимит участников',
            '100 Мб дискового пространства',
          ],
          button: {
            link: this.signupUrl,
            cssClass: 'ui-button-primary-outline mod_size-m',
            text: [
              'Зарегистрироваться',
            ],
          },
        },
        pro: {
          name: 'Персональный',
          description: () => this.monthly ? '590 руб./мес' : '475 руб./мес с оплатой за год',
          features: [
            'Безлимит рабочих пространств',
            'Безлимит файлов',
            'Безлимит участников',
            'Безлимит дискового пространства',
          ],
          button: {
            link: this.signupUrlPro,
            cssClass: 'ui-button-primary mod_size-m',
            text: [
              'Получить персональный тариф',
              'Купить',
            ],
          },
        },
        enterprise: {
          name: 'Корпоративный',
          description: () => 'Свяжитесь с нами',
          features: [
            'Все из персонального тарифа',
            'Расширенная безопасность',
            'Облако или закрытый контур',
            'SSO',
            'Приоритетная поддержка',
          ],
          button: {
            link: 'mailto:info@coverse.team',
            cssClass: 'ui-button-primary-outline mod_size-m',
            text: [
              'Отправить запрос',
            ],
          },
        },
      }
    }
  },
}
</script>

<style scoped lang="scss">
@import "@/../node_modules/bootstrap/scss/functions";
@import "@/../node_modules/bootstrap/scss/variables";
@import "@/../node_modules/bootstrap/scss/mixins";
@import "@/../node_modules/bootstrap/scss/utilities";
@import "@/styles/breakpoints";
@import "@/styles/fonts";
@import "@/styles/button-primary-outline";
@import "@/styles/button-primary";

.plan-card {
  background: #fff;
  padding: 20px 30px;
  border-radius: 5px;
  width: 378px;
  color: #333334;
  height: 382px;
  position: relative;
  border: 2px solid #dae8e8;

  .tablet-button {
    display: none;
  }
}

.plan-name {
  float: left;
  font-size: 20px;
  line-height: 20px;
  font-weight: 700;
  margin-bottom: 12px;
}

.plan-price {
  font-size: 14px;
  line-height: 20px;
  font-weight: 600;
  margin-bottom: 20px;

  .plan-cost {
    font-size: 20px;
    line-height: 20px;
    font-weight: 700;
    margin-right: 7px;
    .plan-cost-low {
      font-size: 14px;
    }
  }
}

.plan-desc {
  clear: both;
  font-size: 14px;
  line-height: 20px;
  margin-bottom: 35px;
}

.plan-hr {
  height: 1px;
  background: #dae8e8;
}

.features-wrapper {
  margin-top: 18px;

  .features {
    .feature {
      position: relative;
      margin-bottom: 10px;

      .feature-icon {
        position: absolute;
        left: -1px;
        top: -4px;

        svg {
          width: 20px;
          height: 20px;
          fill: #58D682;
        }
      }

      .feature-text {
        font-size: 14px;
        line-height: 20px;
        padding-left: 28px;
      }
    }
  }
}

.get-started {
  position: absolute;
  left: 30px;
  right: 30px;
  bottom: 26px;
}

.button-text-regular {
  display: block;
}

.button-text-short {
  display: none;
}

@include media-breakpoint-down($size-desktop) {
  .plan-card {
    width: 320px;
  }
}

@include media-breakpoint-down($size-tablet) {
  .plan-card {
    width: 280px;
    padding: 19px 16px 32px;

    .plan-desc {
      font-size: 12px;
      white-space: nowrap;
      margin-bottom: 15px;
    }
  }

  .features-wrapper {
    margin-top: 20px;
    padding: 0 3px;

    .features {
      .feature {
        .feature-text {
          font-size: 12px;
          line-height: 18px;
        }
      }
    }
  }

  .tablet-button {
    display: block;
  }

  .get-started {
    position: absolute;
    left: 20px;
    right: 20px;
    bottom: 27px;
  }

  .button-text-regular {
    display: none;
  }

  .button-text-short {
    display: block;
  }
}

@include media-breakpoint-down($size-tablet-s) {
  .plan-card {
    width: 226px;
  }
}

@include media-breakpoint-down($size-mobile) {
  .plan-name {
    float: none;
    margin-bottom: 9px;
  }

  .plan-price {
    margin-bottom: 24px;
  }

  .plan-desc {
    margin-bottom: 26px;
    line-height: 26px;

    &.mobile {
      display: block;
    }
  }

  .plan-what {
    margin-top: 23px;
  }

  .plan-card {
    width: 100%;
    max-width: 460px;
    height: 400px;

    .plan-desc {
      font-size: 14px;
      margin-bottom: 32px;
    }
  }

  .features-wrapper {
    .features {
      float: none;
      width: 100%;

      .feature {
        .feature-text {
          font-size: 14px;
          line-height: 20px;
        }
      }
    }
  }

  .get-started {
    margin-top: 35px;
  }
}
</style>
